import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import Utils from '../util';

@Injectable({
  providedIn: 'root'
})
export class InputListGuard  {
  constructor(private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (!Utils.hasInputListAccess()) {
        this.router.navigate(['/project-input']);
        return false;
      }
      return true;
  }
}
